// Escalation Policies
export const FETCH_ESCALATION_POLICIES = 'FETCH_ESCALATION_POLICIES';
export const FETCH_ESCALATION_POLICIES_SUCCESS = 'FETCH_ESCALATION_POLICIES_SUCCESS';
export const FETCH_ESCALATION_POLICIES_FAIL = 'FETCH_ESCALATION_POLICIES_FAIL';

export const FETCH_ESCALATION_POLICY = 'FETCH_ESCALATION_POLICY';
export const FETCH_ESCALATION_POLICY_SUCCESS = 'FETCH_ESCALATION_POLICY_SUCCESS';
export const FETCH_ESCALATION_POLICY_FAIL = 'FETCH_ESCALATION_POLICY_FAIL';

export const CREATE_ESCALATION_POLICY = 'CREATE_ESCALATION_POLICY';
export const CREATE_ESCALATION_POLICY_SUCCESS = 'CREATE_ESCALATION_POLICY_SUCCESS';
export const CREATE_ESCALATION_POLICY_FAIL = 'CREATE_ESCALATION_POLICY_FAIL';

export const UPDATE_ESCALATION_POLICY = 'UPDATE_ESCALATION_POLICY';
export const UPDATE_ESCALATION_POLICY_SUCCESS = 'UPDATE_ESCALATION_POLICY_SUCCESS';
export const UPDATE_ESCALATION_POLICY_FAIL = 'UPDATE_ESCALATION_POLICY_FAIL';

export const DELETE_ESCALATION_POLICY = 'DELETE_ESCALATION_POLICY';
export const DELETE_ESCALATION_POLICY_SUCCESS = 'DELETE_ESCALATION_POLICY_SUCCESS';
export const DELETE_ESCALATION_POLICY_FAIL = 'DELETE_ESCALATION_POLICY_FAIL';

export const TOGGLE_ESCALATION_POLICY = 'TOGGLE_ESCALATION_POLICY';
export const TOGGLE_ESCALATION_POLICY_SUCCESS = 'TOGGLE_ESCALATION_POLICY_SUCCESS';
export const TOGGLE_ESCALATION_POLICY_FAIL = 'TOGGLE_ESCALATION_POLICY_FAIL';

// Escalation Events (Audit Log)
export const FETCH_ESCALATION_EVENTS = 'FETCH_ESCALATION_EVENTS';
export const FETCH_ESCALATION_EVENTS_SUCCESS = 'FETCH_ESCALATION_EVENTS_SUCCESS';
export const FETCH_ESCALATION_EVENTS_FAIL = 'FETCH_ESCALATION_EVENTS_FAIL';

// Clear messages
export const CLEAR_ESCALATION_MESSAGES = 'CLEAR_ESCALATION_MESSAGES';
